module.exports = "/fonts/TT_Norms_Pro_ExtraBold.ttf";